module.exports = __webpack_public_path__ + "static/media/400020_02.3073bc5d.png";